import { render, staticRenderFns } from "./TabReportMensileAdmin.vue?vue&type=template&id=10875873&"
import script from "./TabReportMensileAdmin.vue?vue&type=script&lang=js&"
export * from "./TabReportMensileAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabReportMensileAdmin.vue
// module id = 890
// module chunks = 0